import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '../../../pipes/translate.pipe';

@Component({
  selector: 'app-not-found',
  imports: [MatButtonModule, TranslatePipe],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {
  constructor(private router: Router) {}

  onRedirect() {
    this.router.navigate(['']).then(() => {});
  }
}
